import { render, staticRenderFns } from "./permission-package.vue?vue&type=template&id=2bd02302&scoped=true&"
import script from "./permission-package.vue?vue&type=script&lang=js&"
export * from "./permission-package.vue?vue&type=script&lang=js&"
import style0 from "./permission-package.vue?vue&type=style&index=0&id=2bd02302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd02302",
  null
  
)

export default component.exports